import { onAxiosRequest, onAxiosResponse } from "@3gaam/app/src/axiosConfig";
import { config } from "@3gaam/app/src/config";
import { handleMessages } from "@3gaam/app/src/firebaseMessageHandler";
import { store } from "@3gaam/app/src/store";
import { identityAction } from "@3gaam/app/src/store/auth";
import {
  handleShowModalAction,
  setShowPageLoader,
} from "@3gaam/app/src/store/general";
import { useAppSelector } from "@3gaam/app/src/store/hooks";
import { logoutHandler } from "@3gaam/app/src/utils/auth";
import PageLoader from "@3gaam/shared/components/general/pageLoader";
import { getUrlParameter } from "@3gaam/shared/utils/urlHelper";
import React from "react";

const redirectToLogin = (returnUrl: string) => {
  let qs = "";
  if (returnUrl) {
    qs += `ReturnUrl=${encodeURIComponent(window.location.href)}`;
  }
  window.location.replace(`${config.authenticateUrl}/Login?${qs}`);
};

export default function <T extends object>(Component: React.ComponentType<T>) {
  const _consulteeId = getUrlParameter("ConsulteeId");
  if (_consulteeId) {
    localStorage.clear();
    localStorage.setItem("ConsulteeId", _consulteeId);
    localStorage.setItem("ReturnUrl", getUrlParameter("ReturnUrl"));
  }

  const unsubscribe = store.subscribe(() => {
    const { isLoggedIn, isValidationFinished } = store.getState().auth;
    if (!(isValidationFinished && isLoggedIn)) return;

    unsubscribe();
    handleMessages();
  });

  let showUpdateModal = ({
    ignorable,
    message,
    latestVersion,
  }: {
    ignorable: boolean;
    message: string;
    latestVersion?: string;
  }) => {
    store.dispatch(
      handleShowModalAction("updateModal", {
        ignorable,
        message,
        latestVersion,
      }),
    );
  };

  onAxiosRequest();
  onAxiosResponse(showUpdateModal);

  store.dispatch(identityAction());
  store.dispatch(setShowPageLoader(true));
  const unsubscribeFromTokenValidation = store.subscribe(() => {
    const state = store.getState();
    if (state.auth.isValidationFinished) {
      unsubscribeFromTokenValidation();
      if (state.auth.isForbidden) {
        logoutHandler({ clearCookie: false }).then(() => {
          redirectToLogin(window.origin);
        });
      } else {
        store.dispatch(setShowPageLoader(false));
      }
    }
  });

  const InitializedApp: React.FC<T> = (props) => {
    const showPageLoader = useAppSelector(
      (state) => state.general.showPageLoaderCounter,
    );

    if (showPageLoader) {
      return <PageLoader />;
    }

    return <Component {...props} />;
  };

  return InitializedApp;
}
